var chunkMapping = {
	"8517": [
		308517
	],
	"16666": [
		29529
	],
	"19252": [
		619252
	],
	"22815": [
		322815
	],
	"29529": [
		29529
	],
	"32148": [
		569069
	],
	"41528": [
		551977,
		101614
	],
	"43039": [
		404657,
		894713,
		227054,
		836534
	],
	"43944": [
		543944
	],
	"54871": [
		654871
	],
	"67624": [
		564011,
		956443
	],
	"69069": [
		569069
	],
	"70783": [
		818768,
		545819,
		39077,
		694249,
		954457,
		895332
	],
	"71132": [
		971132
	],
	"73165": [
		873165
	],
	"75619": [
		475619
	],
	"95919": [
		895919
	],
	"99648": [
		899648
	]
};
var idToExternalAndNameMapping = {
	"29529": [
		"default",
		"./components/TeachingCard",
		369767
	],
	"39077": [
		"default",
		"./components/GradingRubric",
		369767
	],
	"101614": [
		"default",
		"./components/Presentation",
		369767
	],
	"227054": [
		"default",
		"./utils/html-doc",
		369767
	],
	"308517": [
		"default",
		"./components/Icon/FocusIcon",
		369767
	],
	"322815": [
		"default",
		"./components/HelpCenter",
		369767
	],
	"404657": [
		"default",
		"./components/HtmlWithPinyin",
		369767
	],
	"475619": [
		"default",
		"./components/Question",
		369767
	],
	"543944": [
		"default",
		"./components/UserProfileAvatar",
		369767
	],
	"545819": [
		"default",
		"./components/FullscreenContainer",
		369767
	],
	"551977": [
		"default",
		"./components/NewFlashcard",
		369767
	],
	"564011": [
		"default",
		"./components/Game",
		369767
	],
	"569069": [
		"default",
		"./components/CoreItemsIWGT",
		369767
	],
	"619252": [
		"default",
		"./hooks/dictionary",
		369767
	],
	"654871": [
		"default",
		"./components/UserAvatar",
		369767
	],
	"694249": [
		"default",
		"./components/WritingFeedback/FeedbackSection",
		369767
	],
	"818768": [
		"default",
		"./components/EvaluationForm",
		369767
	],
	"836534": [
		"default",
		"./utils/pinyin",
		369767
	],
	"873165": [
		"default",
		"./avatar/constants",
		369767
	],
	"894713": [
		"default",
		"./hooks/use-resize",
		369767
	],
	"895332": [
		"default",
		"./components/WritingFeedback/hooks/use-writing-feedback",
		369767
	],
	"895919": [
		"default",
		"./components/Quiz",
		369767
	],
	"899648": [
		"default",
		"./components/AudioPlayer",
		369767
	],
	"954457": [
		"default",
		"./components/WritingFeedback/WritingQuestionSection",
		369767
	],
	"956443": [
		"default",
		"./utils/route-change-prompt",
		369767
	],
	"971132": [
		"default",
		"./components/Playbook",
		369767
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_modules__[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_modules__[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}